import React, { useState } from 'react';
import Popup from "../../../components/Popup";
import Message from "../../../components/Message";
import Logo from "../../../components/Logo";
import {useTranslation} from "react-i18next";
import { useThemeContext } from "../../../contexts/ThemeContext";


function Index(props) {
    const { t } = useTranslation();
    const { theme } = useThemeContext();
    return (
        <Popup>
            <div className="pl-3 pr-3">
                <div className="mt-3 text-center">
                    <Logo className="logo mb-3" src={theme?.logo}/>
                    <h1 className="mb-4">{t("Get Started")}</h1>
                </div>
                <Message showIcon className="mb-4" type="message-success" message={<><p>{t("You have been successfully registered!")}</p><p>{t("Please log in to your new account below.")}</p></>}/>
                <div className="text-center">
                    <a className="btn btn-primary" href="/user/login">{t("Return to login")}</a>
                </div>
            </div>
        </Popup>
    );
}

export default Index;